<template>
	<div class="wrapper-template">
		<div class="answer" v-for="(answer, index) in answers" :key="index" @click="selectAnswer(answer)">
			<span :class="[ answersSelected === answer.id ? 'answer-selected' : 'answer-text' ]">
				{{answer.name}}
			</span>
			<img
				:src="answer.urlImage.web"
				alt="icónos de estados"
				:class="{ 'face-not-selected': answersSelected !== answer.id }"
			>
		</div>
	</div>
</template>
<script>

function selectAnswer({ id }) {
	this.$emit('selected-icon', id);
	if (!this.answersSelected) {
		this.$store.commit('UPDATE_POLL_PROGRESS', 1);
	}
	this.answersSelected = id;
}

function data() {
	return {
		answersSelected: 0,
	};
}

export default {
	name: 'faces-text-template',
	data,
	methods: {
		selectAnswer,
	},
	props: {
		answers: {
			default: () => [],
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
	.answer {
		cursor: pointer;
	}

	.face-not-selected {
		filter: brightness(0);
		opacity: 0.2;
	}
</style>




// WEBPACK FOOTER //
// src/components/polls/faces-text-template.vue